module.exports = __webpack_public_path__ + "img/DANIEL_LEAL.c4b1b7c7.jpeg";